import { roundTo } from "../../../../utils";
import LoanReviewField from "../LoanReviewField";
import EditButton from "../EditButton";
import { useState } from "react";
import BusinessLoanModal from "../BusinessLoanModal";
import { useLoanApplication, useLoanCalculator } from "../../../../contexts";
import { useDpConfig } from "../../../../contexts/dpConfig";
import {
  LOAN_PRODUCT_DISPLAY_NAME,
  LoanDurationType,
  LoanProductType,
} from "../../../../hooks/api/types";

const ReceivablesLOCReviewSection = () => {
  const [loanCalculatorModalOpen, setLoanCalculatorModalOpen] = useState(false);

  const {
    state: { products },
  } = useDpConfig();

  const {
    state: { locInvoiceDiscountingLoan },
  } = useLoanApplication();

  const {
    state: { constraints },
  } = useLoanCalculator();

  const currencyUnit = constraints.receivablesCreditLine?.amount?.unit ?? "AED";
  const loanAmount = locInvoiceDiscountingLoan?.amount;
  const durationType =
    locInvoiceDiscountingLoan?.durationType || LoanDurationType.MONTHS;
  const duration = locInvoiceDiscountingLoan?.duration;
  const interestRate = locInvoiceDiscountingLoan?.interestRate;

  const productConfig = products?.find(
    (product: any) => product.type === LoanProductType.LOC_INVOICE_DISCOUNTING
  );

  return (
    <div className="cx-bg-white cx-rounded-lg cx-w-full cx-max-w-full cx-shadow-md cx-p-4 sm:cx-p-5 md:cx-p-10 cx-mt-10">
      <div className="cx-flex cx-flex-row cx-items-center cx-justify-between cx-gap-2 cx-w-full cx-min-w-0">
        <div className="cx-min-w-0 cx-flex-1 cx-text-base md:cx-text-xl cx-font-bold cx-leading-snug">
          {productConfig?.config?.customProductAlias ||
            productConfig?.displayName ||
            LOAN_PRODUCT_DISPLAY_NAME.LOC_INVOICE_DISCOUNTING}
        </div>
        <EditButton onClick={() => setLoanCalculatorModalOpen(true)} />
      </div>
      <div className="cx-flex cx-flex-col sm:cx-flex-row cx-gap-x-10">
        <div className="cx-flex cx-flex-col cx-grow cx-basis-0">
          <LoanReviewField
            value={`${currencyUnit} ${roundTo(
              loanAmount,
              2
            ).toLocaleString()}*`}
            label="Requested line of credit"
            description={`for ${duration} ${durationType}`}
          />
        </div>
        <div className="cx-flex cx-flex-col cx-grow cx-basis-0">
          {import.meta.env.VITE_HARDCODED_INTEREST_RATE ? (
            <LoanReviewField
              label="Interest rate"
              value={`${import.meta.env.VITE_HARDCODED_INTEREST_RATE}%*`}
              description="charged on the borrowed invoices"
            />
          ) : (
            <LoanReviewField
              label="Interest rate"
              value={`Pay as low as ${roundTo((interestRate / 12) * 100, 2)}%*`}
              description="charged on the borrowed invoices"
            />
          )}
        </div>
      </div>
      <BusinessLoanModal
        isOpen={loanCalculatorModalOpen}
        onClose={() => {
          setLoanCalculatorModalOpen(false);
        }}
      />
    </div>
  );
};

export default ReceivablesLOCReviewSection;
